// extracted by mini-css-extract-plugin
module.exports = {"customNavbar":"waveheader_customNavbar__jMsdp"};